import gameIds from 'a/hub/data/GameIds';

export const GAME_ID = gameIds.WILD_PLANET;

export const LEVEL_MASTERY_THRESHOLD = 0.7;

// increment this value if you need to change the shape of a user's save data
// in a way that will invalidate previous data.
// the saveDataReducer will automatically ignore any save data with a version lower than this value.
export const CURRENT_SAVE_DATA_VERSION = 2;

export const CURRICULUM_VERSION = '3.0';

export const QUESTION_TYPE = {
  MAIN_IDEA: 'Main Idea',
  SUPPORTING_FACT: 'Supporting Fact',
  SUMMATIVE: 'Summative',
};

export const POSES = {
  CONFUSED: '1',
  HANDS_ON_WAIST: '2',
  WAVING_HAND: '3',
  ARMS_OUTSTRETCHED: '4',
};

// Game screens
export const SCREENS = {
  PROGRESS: 'PROGRESS',
  STANDARD: 'STANDARD',
  LOADING: 'LOADING',
  LIVE_CHAT: 'LIVE_CHAT',
  INTRODUCTION: 'INTRODUCTION',
};

export const DIRECT_MESSAGE_CONTEXT = {
  HELP: 'HELP',
  GO_TO_STANDARD: 'GO_TO_STANDARD',
  LEVEL_MASTERED: 'LEVEL_MASTERED',
  LEVEL_FAILED: 'LEVEL_FAILED',
  ONBOARDING: 'ONBOARDING',
  LIVE_CHAT_INTRO: 'LIVE_CHAT_INTRO',
  INCORRECT_RESPONSE: 'INCORRECT_RESPONSE',
  CORRECT_RESPONSE: 'CORRECT_RESPONSE',
};

export const DIRECT_MESSAGE_TYPES = {
  INFO: 'INFO',
  ERROR: 'ERROR',
  SUCCESS: 'SUCCESS',
};

export const DIRECT_MESSAGE_IDS = {
  CHAT_INTRO: 'CHAT_INTRO',
  ITEM_INTRO: 'ITEM_INTRO',
  QUESTION_INTRO: 'QUESTION_INTRO',
  HELP_MAIN_IDEA: 'HELP_MAIN_IDEA',
  HELP_SUPPORTING_FACT: 'HELP_SUPPORTING_FACT',
  HELP_SUMMATIVE: 'HELP_SUMMATIVE',
  INCORRECT_MAIN_IDEA: 'INCORRECT_MAIN_IDEA',
  CORRECT_MAIN_IDEA: 'CORRECT_MAIN_IDEA',
  INCORRECT_SUPPORTING_FACT: 'INCORRECT_SUPPORTING_FACT',
  CORRECT_SUPPORTING_FACT: 'CORRECT_SUPPORTING_FACT',
  INCORRECT_SUMMATIVE: 'INCORRECT_SUMMATIVE',
  CORRECT_SUMMATIVE: 'CORRECT_SUMMATIVE',
  LEVEL_FAILED: 'LEVEL_FAILED',
  LEVEL_MASTERED: 'LEVEL_MASTERED',
};

export const REDUX_ACTIONS = {
  CHANGE_SCREEN: 'CHANGE_SCREEN',
  INITIALIZE_ROUND: 'INITIALIZE_ROUND',
  NEXT_STANDARD_ITEM: 'NEXT_STANDARD_ITEM',
  SAVE_DATA_BY_KEY: 'SAVE_DATA_BY_KEY',
  CLEAR_SAVE_DATA_BY_KEY: 'CLEAR_SAVE_DATA_BY_KEY',
  SET_LEVEL_INDEX: 'SET_LEVEL_INDEX',
  ADD_NEXT_MESSAGE: 'ADD_NEXT_MESSAGE',
  INITIALIZE_STANDARD_ITEM: 'INITIALIZE_STANDARD_ITEM',
  COMPLETE_STD_ITEM: 'COMPLETE_STD_ITEM',
  ADD_BATCH_OF_MESSAGES: 'ADD_BATCH_OF_MESSAGES',
  SWITCH_PASSAGE: 'SWITCH_PASSAGE',
  SHOW_DIRECT_MESSAGE: 'SHOW_DIRECT_MESSAGE',
  HIDE_DIRECT_MESSAGE: 'HIDE_DIRECT_MESSAGE',
  SET_UP_DIRECT_MESSAGE: 'SET_UP_DIRECT_MESSAGE',
  SET_IS_OVERLAY_ENABLED: 'SET_IS_OVERLAY_ENABLED',
  SET_LAST_LEVEL_UNLOCKED: 'SET_LAST_LEVEL_UNLOCKED',
  SET_CURRENT_VO_NAME: 'SET_CURRENT_VO_NAME',
  ON_VO_ENDS: 'ON_VO_ENDS',
  STOP_VO: 'STOP_VO',
  UPDATE_RECORDS: 'UPDATE_RECORDS',
  INCREASE_ATTEMPT: 'INCREASE_ATTEMPT',
  COMPLETE_QUESTION: 'COMPLETE_QUESTION',
  OPEN_NEXT_QUESTION: 'OPEN_NEXT_QUESTION',
};
